import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedChargebacksInfoData } from "mappers";
import { chargebacksDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetChargebackInfoQueryProps = {
	chargebackId: string;
};

const useGetChargebackInfoQuery = ({
	chargebackId,
}: useGetChargebackInfoQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["chargebackInfo", chargebackId],
		() =>
			chargebacksDetailsService.getChargebackInfo({
				chargebackId,
			}),
		{
			select: data => {
				return getMappedChargebacksInfoData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!chargebackId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetChargebackInfoQuery;
